<div>
  <div class="page-title">
    <h1>Shipments
      <button class="btn btn-primary" routerLink="/main/addEditShipment">Create New</button>
    </h1>
  </div>
  <div class="page-body">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="">Search</label>
          <input type="text" class="form-control" [(ngModel)]="tableModel.search">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="">Start date</label>
          <input type="date" class="form-control" [(ngModel)]="tableModel.startDate">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="">End date</label>
          <input type="date" class="form-control" [(ngModel)]="tableModel.endDate">
        </div>
      </div>
      <div class="col-md-3" style="align-content: center;">
        <button class="btn btn-primary mr-3" (click)="getList()">Search</button>
        <button class="btn btn-primary mr-3" (click)="reset()">Reset</button>
        <button class="btn btn-primary" *ngIf="selectedItems.length>0" (click)="print()">Print Selected</button>
      </div>
    </div>
    <div class="card mt-3">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="dataSource.data.length>0">

        <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="masterToggle($event)">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element"> <mat-checkbox 
            (change)="toggleSelection(element.lable)"
            [checked]="isSelected(element)">
            </mat-checkbox></td>
        </ng-container>
        <!-- Position Column -->
        <ng-container matColumnDef="parcelID">
          <th mat-header-cell *matHeaderCellDef> Name  </th>
          <td mat-cell *matCellDef="let element"> {{element.toAddress.name}}</td>
        </ng-container>
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef style="width: 10%;"> To Address  </th>
          <td mat-cell *matCellDef="let element" style="width: 10%;"> {{element.toAddress.addressLine1}}, {{element.toAddress.cityTown}}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="salesOrderNumber">
          <th mat-header-cell *matHeaderCellDef> Sales Order No. </th>
          <td mat-cell *matCellDef="let element"> {{element.salesOrderNumber}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="trackNo">
          <th mat-header-cell *matHeaderCellDef> Tracking No. </th>
          <td mat-cell *matCellDef="let element"> {{element.parcelTrackingNumber}} </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="service">
          <th mat-header-cell *matHeaderCellDef> Service </th>
          <td mat-cell *matCellDef="let element"> {{
            element.service== "UGA" ? "USPS Ground Advantage" :
            element.service== "PM" ?  "USPS Priority Mail" :
            element.service== "GRD" ? "UPS Ground" :
            element.service== "2DA" ? "UPS 2nd Day Air" :
            element.service== "NDA_SVR" ? "UPS Next Day Air Saver" :element.service
          }} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="shipmentID">
          <th mat-header-cell *matHeaderCellDef> Shipment ID </th>
          <td mat-cell *matCellDef="let element"> {{
            element.shipmentId
          }} </td>
        </ng-container>
        
        <!-- Symbol Column -->
        <ng-container matColumnDef="dimensions">
          <th mat-header-cell *matHeaderCellDef> Dimensions </th>
          <td mat-cell *matCellDef="let element"> {{
            element.dimensions
          }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="width: 10%;"> Status </th>
          <td mat-cell *matCellDef="let element" style="width: 10%;"> {{element.status}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element">
            <i class="icon-eye icon-btn" (click)="view(element.shipmentId)"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <h4 class="text-center" *ngIf="!(dataSource.data.length>0)">No Records Found</h4>
      <mat-paginator #paginator [length]="total" [pageSizeOptions]="[10, 50, 100]"   [pageSize]="tableModel.size"  showFirstLastButtons 
      (page)="onPaginate($event)">
      </mat-paginator>
    </div>
  </div>
</div>